import type React from "react";

export type SidebarIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

type IconProps = React.SVGProps<SVGSVGElement>;

function IconBase({ children, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function ExploreIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M3.9 11.2 12 4.25l8.1 6.95" />
      <path d="M5.35 10.05v8.2a1.55 1.55 0 0 0 1.55 1.55h10.2a1.55 1.55 0 0 0 1.55-1.55v-8.2" />
      <path d="M9.5 16.8h5" />
    </IconBase>
  );
}

export function ProductsIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M3.7 7.85a1.9 1.9 0 0 1 1.9-1.9h4.15l1.75 2.1h6.9a1.9 1.9 0 0 1 1.9 1.9v7.55a1.9 1.9 0 0 1-1.9 1.9H5.6a1.9 1.9 0 0 1-1.9-1.9z" />
      <path d="M3.7 10.1h16.6" />
    </IconBase>
  );
}

export function ProductShowcaseIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M9.85 5.2h4.3" />
      <path d="M10.75 5.2v2.35l-1.8 1.45v7.25a2 2 0 0 0 2 2h2.1a2 2 0 0 0 2-2V9l-1.8-1.45V5.2" />
      <path d="M9.15 11.15h5.7" />
      <path d="M10.65 14.75h2.7" />
      <path d="M5 19.65c1.9 1.15 4.25 1.8 7 1.8s5.1-.65 7-1.8" />
      <path d="m17.65 6.55.55-1.2.55 1.2 1.2.55-1.2.55-.55 1.2-.55-1.2-1.2-.55z" />
    </IconBase>
  );
}

export function BrandsIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M2 15c6.667-6 13.333 0 20-6" />
      <path d="M9 22c1.798-1.998 2.518-3.995 2.807-5.993" />
      <path d="M15 2c-1.798 1.998-2.518 3.995-2.807 5.993" />
      <path d="m17 6-2.5-2.5" />
      <path d="m14 8-1-1" />
      <path d="m7 18 2.5 2.5" />
      <path d="m3.5 14.5.5.5" />
      <path d="m20 9 .5.5" />
      <path d="m6.5 12.5 1 1" />
      <path d="m16.5 10.5 1 1" />
      <path d="m10 16 1.5 1.5" />
    </IconBase>
  );
}

export function WorkspacesIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="m3.6 7.6 8.4-3.85 8.4 3.85L12 11.45z" />
      <path d="m3.6 12 8.4 3.85L20.4 12" />
      <path d="m3.6 16.4 8.4 3.85 8.4-3.85" />
    </IconBase>
  );
}

export function AdsStudioIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <rect width="18" height="7" x="3" y="3" rx="1" />
      <rect width="9" height="7" x="3" y="14" rx="1" />
      <rect width="5" height="7" x="16" y="14" rx="1" />
    </IconBase>
  );
}

export function ImageAdsIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
    </IconBase>
  );
}

export function VideoAdsIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <rect width="18" height="18" x="3" y="3" rx="2" />
      <path d="m10 8 6 4-6 4Z" />
    </IconBase>
  );
}

export function AssetsIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
    </IconBase>
  );
}

export function PaidCampaignsIcon(props: IconProps) {
  return (
    <img
      src="/meta-color.svg"
      alt=""
      aria-hidden="true"
      className={props.className as string | undefined}
    />
  );
}

export function GoogleCampaignsIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      className={props.className as string | undefined}
    >
      <path
        d="M21.6 12.227c0-.709-.064-1.39-.182-2.045H12v3.868h5.382a4.6 4.6 0 0 1-1.995 3.018v2.51h3.232c1.891-1.742 2.981-4.305 2.981-7.351z"
        fill="#4285F4"
      />
      <path
        d="M12 22c2.7 0 4.964-.895 6.619-2.422l-3.232-2.51c-.895.6-2.04.955-3.387.955-2.605 0-4.81-1.76-5.595-4.123H3.064v2.59A9.996 9.996 0 0 0 12 22z"
        fill="#34A853"
      />
      <path
        d="M6.405 13.9A6.013 6.013 0 0 1 6.09 12c0-.659.114-1.3.314-1.9V7.51H3.064A9.996 9.996 0 0 0 2 12c0 1.614.386 3.14 1.064 4.49l3.341-2.59z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.977c1.468 0 2.787.505 3.823 1.495l2.868-2.868C16.96 2.99 14.696 2 12 2 8.09 2 4.708 4.245 3.064 7.51l3.34 2.59C7.19 7.736 9.396 5.977 12 5.977z"
        fill="#EA4335"
      />
    </svg>
  );
}

export function OrganicCampaignsIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M5.35 5.75h13.3a1.95 1.95 0 0 1 1.95 1.95v10.5a1.95 1.95 0 0 1-1.95 1.95H5.35A1.95 1.95 0 0 1 3.4 18.2V7.7a1.95 1.95 0 0 1 1.95-1.95Z" />
      <path d="M3.4 10.45h17.2" />
      <path d="M8 3.85v3.85" />
      <path d="M16 3.85v3.85" />
      <path d="M7.6 15.25h8.8" />
    </IconBase>
  );
}

export function LightModeIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M12 7.35a4.65 4.65 0 1 0 0 9.3 4.65 4.65 0 0 0 0-9.3Z" />
      <path d="M12 3.75v1.55" />
      <path d="M12 18.7v1.55" />
      <path d="m5.85 5.85 1.1 1.1" />
      <path d="m17.05 17.05 1.1 1.1" />
      <path d="M3.75 12h1.55" />
      <path d="M18.7 12h1.55" />
      <path d="m5.85 18.15 1.1-1.1" />
      <path d="m17.05 6.95 1.1-1.1" />
    </IconBase>
  );
}

export function DarkModeIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M17.85 15.1a6.55 6.55 0 0 1-8.95-8.95 7.25 7.25 0 1 0 8.95 8.95Z" />
      <path d="M14.7 5.05h.05" />
      <path d="M18.2 8.45h.05" />
    </IconBase>
  );
}

export function SettingsIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M5.25 7.55h13.5" />
      <path d="M5.25 12h13.5" />
      <path d="M5.25 16.45h13.5" />
      <path d="M9.15 7.55a1.35 1.35 0 1 0 2.7 0 1.35 1.35 0 0 0-2.7 0Z" />
      <path d="M13.25 12a1.35 1.35 0 1 0 2.7 0 1.35 1.35 0 0 0-2.7 0Z" />
      <path d="M7.65 16.45a1.35 1.35 0 1 0 2.7 0 1.35 1.35 0 0 0-2.7 0Z" />
    </IconBase>
  );
}

export function ProfileIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M12 11.35a3.15 3.15 0 1 0 0-6.3 3.15 3.15 0 0 0 0 6.3Z" />
      <path d="M5.55 19.15c.55-3.35 3-5.15 6.45-5.15s5.9 1.8 6.45 5.15" />
      <path d="M8.7 17.55h6.6" />
    </IconBase>
  );
}

export function SidebarOpenIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="m13 17 5-5-5-5" />
      <path d="m6 17 5-5-5-5" />
    </IconBase>
  );
}

export function SidebarCloseIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="m11 17-5-5 5-5" />
      <path d="m18 17-5-5 5-5" />
    </IconBase>
  );
}
